import { twMerge } from "tailwind-merge";

import { ToggleButtonGroup } from "ui/toggle-button-group";
import { Switch } from "ui/switch";
import { IconButton } from "ui/icon-button";
import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import { ViewModeOption } from "containers/admin/clients/client/theme-page/preview/preview.types";

import Icons from "assets";

const viewOptions = [
  {
    label: (
      <span className="flex items-center gap-2">
        <Icons.Mobile className="size-4" />
        Mobile
      </span>
    ),
    value: "Mobile",
  },
  {
    label: (
      <span className="flex items-center gap-2">
        <Icons.Desktop className="size-4" />
        Desktop
      </span>
    ),
    value: "Desktop",
  },
];

const PreviewSettings = ({ onClose }: { onClose: () => void }) => {
  const { viewMode, setViewMode, isFallbackFontApplied, setIsFallbackFontApplied, isSettingsOpen } =
    useThemePreviewContext();

  const containerStyles = twMerge(
    "h-full w-64 bg-gray-100 border-l border-zinc-200 transition-all duration-300 ease-in-out",
    isSettingsOpen ? "w-64 opacity-100" : "w-0 opacity-0 overflow-hidden",
  );

  if (!isSettingsOpen) return null;

  return (
    <div className={containerStyles}>
      <div className="flex items-center justify-between pl-7 pr-5 pt-4 pb-3">
        <span className="font-bold text-sm tracking-widest text-gray-500 ">SETTINGS</span>

        <IconButton aria-label="Close settings" variant="text" onClick={onClose}>
          <Icons.Sidebar className="text-neutrals-500" />
        </IconButton>
      </div>
      <div className="h-full">
        <div className="flex flex-col p-7 pt-0 gap-5">
          <div className="w-full">
            <ToggleButtonGroup
              groupName="preview-modes-toggle"
              options={viewOptions}
              onChange={(option) => {
                setViewMode(option as ViewModeOption);
              }}
              value={viewMode}
              size="sm"
            />
          </div>
          <div>
            <Switch
              toggleName="Base font style"
              checked={isFallbackFontApplied}
              onChange={setIsFallbackFontApplied}
              labelPlacement="start"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewSettings;
